module.exports = __webpack_public_path__ + "static/media/funnels-preview.0501d602.png";